import { Row, Col, Image, Container } from 'react-bootstrap';
import httlogo from '../images/httwhite.png';
import '../style.css'
function BottomMenu() {
    return (
        <div id="BottomMenu">
            <Container>
                <br />
                <Row id="justify-content-end">
                    <Col md={3}>
                        <Image
                            src={httlogo}
                            width={'100%'}
                        />
                    </Col>
                    <Col md={2}>
                        <h3 className='htitle'>LOCATION</h3>
                        <p>311 Pacific Street  <br />
                            Honolulu, Hawaii 96817</p>
                    </Col>
                    <Col md={7}>
                        <h3 className='htitle'>CONTACT</h3>
                        <Row>
                            <Col>
                                <h5>Parts Department</h5> 
                                <p>808-532-7502 <br /> (7:00am – 4:00pm)</p>
                            </Col>
                            <Col>
                                <h5>Service Department</h5>
                                <p>808-532-7512 <br /> (7:00am – 3:30pm)</p>
                            </Col>
                            <Col>
                                <h5>Truck Sales Department</h5>
                                <p>808-532-7501 <br /> (7:00am – 4:00pm)</p>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <hr />
                <p className='text-center'><a id="custom-a" href="http://htt-hawaii.com">HT&T Truck Center</a> & <a id="custom-a" href="https://beihawaii.com">BEI Hawaii</a> are owned by <a id="custom-a" href="http://marathongrouphi.com">Marathon Group</a></p>
                <br />
            </Container>
        </div>
    );
}

export default BottomMenu;